import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export enum GraphsTab {
    ManagedPortfolio = 'managed-portfolio',
    OtherServiceProviders = 'other-service-providers'
}

function getTabIndexFromName(tabName: GraphsTab) {
    switch (tabName) {
        case GraphsTab.ManagedPortfolio:
            return 0;
        case GraphsTab.OtherServiceProviders:
            return 1;
        default:
            return 0;
    }
}

function getNameFromTabIndex(tabIndex: number) {
    switch (tabIndex) {
        case 0:
            return GraphsTab.ManagedPortfolio;
        case 1:
            return GraphsTab.OtherServiceProviders;
        default:
            return GraphsTab.ManagedPortfolio;
    }
}

export function useGraphsTab() {
    const [params, setParams] = useSearchParams();

    const selectedTabIndex = useMemo(() => {
        const tabName = params.get('graphs-tab') as GraphsTab | null;

        if (tabName === null) {
            return 0;
        }

        return getTabIndexFromName(tabName);
    }, [params]);

    const selectedTabName = useMemo(
        () => getNameFromTabIndex(selectedTabIndex),
        [selectedTabIndex]
    );

    const setTabByName = (tabName: GraphsTab) => {
        setParams((old) => {
            old.set('graphs-tab', tabName);
            return old;
        });
    };

    const setTabByIndex = (tabIndex: number) => {
        setParams((old) => {
            old.set('graphs-tab', getNameFromTabIndex(tabIndex));
            return old;
        });
    };

    return {
        selectedTabName,
        selectedTabIndex,
        setTabByName,
        setTabByIndex,
    };
}
